var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.999 8.00001C15.999 9.05065 15.7921 10.091 15.39 11.0617C14.988 12.0323 14.3987 12.9143 13.6558 13.6572C12.9128 14.4001 12.0309 14.9894 11.0602 15.3915C10.0895 15.7936 9.04919 16.0005 7.99855 16.0005C6.94791 16.0005 5.90755 15.7936 4.93689 15.3915C3.96622 14.9894 3.08425 14.4001 2.34134 13.6572C1.59842 12.9143 1.00911 12.0323 0.607049 11.0617C0.204986 10.091 -0.00195314 9.05065 -0.00195312 8.00001C-0.00195309 5.87815 0.840954 3.84319 2.34134 2.3428C3.84172 0.842419 5.87668 -0.000488281 7.99855 -0.000488281C10.1204 -0.000488281 12.1554 0.842419 13.6558 2.3428C15.1561 3.84319 15.999 5.87815 15.999 8.00001Z",
    fill: "url(#paint0_linear_10487_18925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 12.765C5.33203 12.902 5.42603 13 5.58203 13C5.93303 13 6.41803 12.375 7.99903 12.375C9.58003 12.375 10.066 13 10.416 13C10.572 13 10.666 12.902 10.666 12.765C10.666 12.368 9.82703 11 7.99903 11C6.17103 11 5.33203 12.368 5.33203 12.765Z",
    fill: "url(#paint1_linear_10487_18925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59873 8.79998C3.59873 7.98998 4.10773 7.33398 4.73273 7.33398C5.35973 7.33398 5.86673 7.98998 5.86673 8.79998C5.86673 9.13798 5.77673 9.44998 5.62873 9.69798C5.56212 9.80986 5.45388 9.89077 5.32773 9.92298C5.18773 9.95998 4.97473 9.99998 4.73273 9.99998C4.48973 9.99998 4.27973 9.95998 4.13773 9.92298C4.01185 9.89073 3.90394 9.8098 3.83773 9.69798C3.67782 9.42593 3.59587 9.11554 3.59873 8.79998ZM10.1327 8.79998C10.1327 7.98998 10.6407 7.33398 11.2657 7.33398C11.8927 7.33398 12.3997 7.98998 12.3997 8.79998C12.3997 9.13798 12.3097 9.44998 12.1617 9.69798C12.1288 9.75345 12.0853 9.80188 12.0337 9.84049C11.982 9.8791 11.9232 9.90713 11.8607 9.92298C11.4707 10.024 11.0607 10.024 10.6707 9.92298C10.5448 9.89073 10.4369 9.8098 10.3707 9.69798C10.2115 9.42575 10.1292 9.11536 10.1327 8.79998Z",
    fill: "url(#paint2_linear_10487_18925)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10487_18925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59873 8.79998C3.59873 7.98998 4.10773 7.33398 4.73273 7.33398C5.35973 7.33398 5.86673 7.98998 5.86673 8.79998C5.86673 9.13798 5.77673 9.44998 5.62873 9.69798C5.56212 9.80986 5.45388 9.89077 5.32773 9.92298C5.18773 9.95998 4.97473 9.99998 4.73273 9.99998C4.48973 9.99998 4.27973 9.95998 4.13773 9.92298C4.01185 9.89073 3.90394 9.8098 3.83773 9.69798C3.67782 9.42593 3.59587 9.11554 3.59873 8.79998ZM10.1327 8.79998C10.1327 7.98998 10.6407 7.33398 11.2657 7.33398C11.8927 7.33398 12.3997 7.98998 12.3997 8.79998C12.3997 9.13798 12.3097 9.44998 12.1617 9.69798C12.1288 9.75345 12.0853 9.80188 12.0337 9.84049C11.982 9.8791 11.9232 9.90713 11.8607 9.92298C11.4707 10.024 11.0607 10.024 10.6707 9.92298C10.5448 9.89073 10.4369 9.8098 10.3707 9.69798C10.2115 9.42575 10.1292 9.11536 10.1327 8.79998Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.61595 7.98583C4.74395 8.11083 4.75195 8.35783 4.63295 8.53583C4.51295 8.71483 4.31295 8.75883 4.18495 8.63283C4.05695 8.50783 4.04995 8.26083 4.16795 8.08283C4.28795 7.90283 4.48795 7.86083 4.61595 7.98583ZM11.105 7.98583C11.233 8.11083 11.241 8.35783 11.123 8.53583C11.003 8.71483 10.803 8.75883 10.673 8.63283C10.546 8.50783 10.539 8.26083 10.658 8.08283C10.777 7.90283 10.977 7.86083 11.105 7.98583Z",
    fill: "#4E506A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15711 5.15311C4.48911 5.00011 4.75311 4.93311 4.95811 4.93311C5.23511 4.93311 5.40911 5.05311 5.50811 5.24011C5.68311 5.56911 5.60411 5.64011 5.31011 5.69911C4.20411 5.92311 3.09311 6.64111 2.61111 7.08911C2.31111 7.36911 2.02211 7.05911 2.17511 6.81511C2.32911 6.57111 2.94911 5.71011 4.15711 5.15311ZM10.4921 5.24011C10.5921 5.05311 10.7651 4.93411 11.0421 4.93411C11.2481 4.93411 11.5121 5.00011 11.8431 5.15311C13.0511 5.71011 13.6711 6.57111 13.8241 6.81511C13.9771 7.05911 13.6901 7.36911 13.3891 7.08911C12.9061 6.64111 11.7961 5.92311 10.6891 5.69911C10.3951 5.64111 10.3191 5.57011 10.4921 5.24011Z",
    fill: "url(#paint3_linear_10487_18925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16C12.672 16 12 15.252 12 14.329C12 13.407 12.356 12.784 12.643 12.182C13.241 10.924 13.359 10.75 13.5 10.75C13.641 10.75 13.759 10.924 14.357 12.182C14.644 12.784 15 13.407 15 14.329C15 15.252 14.328 16 13.5 16Z",
    fill: "url(#paint4_linear_10487_18925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5002 13.6058C13.1722 13.6058 12.9062 13.3098 12.9062 12.9458C12.9062 12.5798 13.0473 12.3328 13.1613 12.0938C13.3973 11.5958 13.4443 11.5278 13.5013 11.5278C13.5563 11.5278 13.6032 11.5958 13.8392 12.0938C13.9532 12.3338 14.0942 12.5798 14.0942 12.9448C14.0942 13.3098 13.8282 13.6058 13.5002 13.6058Z",
    fill: "url(#paint5_linear_10487_18925)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10487_18925",
    x: 2.59961,
    y: 6.33398,
    width: 10.8008,
    height: 4.66602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0411227 0 0 0 0 0.0430885 0 0 0 0 0.0922353 0 0 0 0.819684 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10487_18925"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10487_18925",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10487_18925",
    x1: 7.99905,
    y1: 1.64001,
    x2: 7.99905,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10487_18925",
    x1: 7.99903,
    y1: 11,
    x2: 7.99903,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#472315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B3A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10487_18925",
    x1: 7.99873,
    y1: 7.33398,
    x2: 7.99873,
    y2: 9.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#3B426A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10487_18925",
    x1: 8.00011,
    y1: 4.93411,
    x2: 8.00011,
    y2: 7.19911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10487_18925",
    x1: 13.5,
    y1: 15.05,
    x2: 13.5,
    y2: 11.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35CAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10487_18925",
    x1: 13.5002,
    y1: 11.5278,
    x2: 13.5002,
    y2: 13.6058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AE1FF",
    stopOpacity: 0.287
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8E3FF",
    stopOpacity: 0.799
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.5993f1c0545d446967d2356b11a38683.svg";
export { ForwardRef as ReactComponent };